import { render, staticRenderFns } from "./el-password.vue?vue&type=template&id=d6637304&lang=pug&"
import script from "./el-password.vue?vue&type=script&lang=ts&"
export * from "./el-password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports